import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Home from '../pages/Home';
import SignIn from '../pages/SignIn';
import Reports from '../pages/Reports';
import callTypeForm from '../components/callTypeForm';
import callSlotForm from '../components/callSlotForm';
import callTypesTable from '../components/CallTypesTable';
import DashboardUserForm from '../components/DashboardUserForm';
import AddTherapist from '../pages/AddTherapist';
import TaskTemplates from '../pages/TaskTemplates';
import Therapistassign from '../pages/TherapistAssign';
import SpeechTherapistSession from '../pages/SpeechTherapistSession';
import MultiTemplate from '../pages/MultiTemplate';
import CreateOffer from '../pages/CreateOffer';
import VideoExercise from '../pages/VideoExercise';

class Body extends Component {
  render() {
    return (
      <Switch>
        <Route path="/login" render={() => { return <SignIn />; }} />
        <PrivateRoute exact path="/" component={Home} />
        <PrivateRoute path="/reports" component={Reports} />
        <PrivateRoute path="/addcalltype" component={callTypeForm} />
        <PrivateRoute path="/addcallslot" component={callSlotForm} />
        <PrivateRoute path="/viewslots" component={callTypesTable} />
        <PrivateRoute path="/therapistassignments" component={Therapistassign} />
        <PrivateRoute path="/add-dashboard-user" component={DashboardUserForm} />
        <PrivateRoute path="/speech-therapist-session" component={SpeechTherapistSession} />
        <PrivateRoute path="/add-therapist" component={AddTherapist} />
        <PrivateRoute path="/templates" component={TaskTemplates} />
        <PrivateRoute path="/multiTemplate" component={MultiTemplate} />
        <PrivateRoute path="/create-offer" component={CreateOffer} />
        <PrivateRoute path="/video-exercise" component={VideoExercise} />
      </Switch>
    );
  }
}

export default Body;
